import { useState, useCallback } from "react";

export function useRefundDialog() {
  const [dialogState, setDialogState] = useState(null);

  const openRefundDialog = useCallback(
    ({
      appointmentObj,
      isOnlyRefund = false,
      forceRefund = false,
      statusToBeApplied = null,
      onRefresh = null,
      newRefundStatus = null,
    }) => {
      setDialogState({
        title: "Process Refund",
        state: 1,
        width: "800px",
        inputValue: "",
        appointmentObj,
        isOnlyRefund,
        forceRefund,
        statusToBeApplied,
        onRefresh,
        newRefundStatus,
        // The refund envelope returned by /refund/create. Holds the groupId shown on the
        // success screen, and — when status is PARTIAL — the failure that keeps the dialog
        // open for a retry.
        refundResult: null,
      });
    },
    [],
  );

  const handleClose = useCallback(() => {
    setDialogState(null);
  }, []);

  return {
    dialogState,
    setDialogState,
    openRefundDialog,
    handleClose,
  };
}
